import { handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString, parseFormDateString } from "../shared/utils/form-date.js";
function formUtils_handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates) {
    handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates, {
        clearEndDateOnStart: true
    });
}
function getPartStaySelectedDates(watchHotelStartDate, watchHotelEndDate, watchStartDate, watchEndDate) {
    if (watchHotelStartDate) return {
        from: parseFormDateString(watchHotelStartDate),
        to: watchHotelEndDate ? parseFormDateString(watchHotelEndDate) : void 0
    };
    return {
        from: watchStartDate ? parseFormDateString(watchStartDate) : void 0,
        to: watchEndDate ? parseFormDateString(watchEndDate) : void 0
    };
}
export { getPartStaySelectedDates, formUtils_handleDateRangeCalendarChange as handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString };
